import { Trans, useTranslation } from 'react-i18next';
import illustration from './images/quick-setup.svg';
import hpeLogo from './images/hpe-logo.svg';
import './App.css';

function App() {
  const { t } = useTranslation('maintenance');
  return (
    <div className="app">
      <header className="app-header">
        <img src={hpeLogo} className="app-header__logo" alt={t('logo_alt', 'HPE logo')} />
        <span className="app-header__title">
          <span>HPE Networking</span>
          <span>Security Director Cloud</span>
        </span>
      </header>
      <main className="content">
        <img src={illustration} className="illustration" alt={t('illustration_alt', 'HPE')} />
        <div className="text-wrapper">
          <h1 className="maintenance-title">{t('title', 'Maintenance in progress')}</h1>
          <p className="maintenance-text">
            <span className="maintenance-text__line">{t('message_line1', 'We are performing planned maintenance.')}</span>
            <span className="maintenance-text__line">
              <Trans
                ns="maintenance"
                i18nKey="message_line2"
                defaults="For more details check <0>Security Director Status</0>"
                components={[
                  // Child text is a fallback for eslint/screen readers; <Trans> injects the translated label at runtime.
                  <a className="maintenance-link" href="https://status.sdcloud.juniperclouds.net/">Security Director Status</a>,
                ]}
              />
            </span>
          </p>
        </div>
      </main>
    </div>
  );
}

export default App;
